/**
 * @generated SignedSource<<12a19be160dfdf694a5a4c8171a08f8e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SummaryHubLinkQuery$variables = Record<PropertyKey, never>;
export type SummaryHubLinkQuery$data = {
  readonly me: {
    readonly id: string;
    readonly isHubAuth: boolean;
  };
};
export type SummaryHubLinkQuery = {
  response: SummaryHubLinkQuery$data;
  variables: SummaryHubLinkQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Me",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isHubAuth",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SummaryHubLinkQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SummaryHubLinkQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "71ba18559fc7a661dc7353b3ed58035c",
    "id": null,
    "metadata": {},
    "name": "SummaryHubLinkQuery",
    "operationKind": "query",
    "text": "query SummaryHubLinkQuery {\n  me {\n    id\n    isHubAuth\n  }\n}\n"
  }
};
})();

(node as any).hash = "17ce51384677380986894c4626bd75f9";

export default node;
